import { useQuery } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getSsoMembershipKey } from '../../utils/keys';
export const useSsoMemberships = (options) => {
    const { useQueryOptions, variables } = options || {};
    const { client } = useTribeClient();
    const ssoMembershipKey = getSsoMembershipKey();
    return useQuery(ssoMembershipKey, () => client.auth.ssoMemberships(variables), useQueryOptions);
};
//# sourceMappingURL=useSsoMemberships.js.map